import { iOrderResponse } from '../interfaces/chrInterfaces';
import { cBigNumber } from './BigNumber';


export class cChromiaOrder {
	ordId: number;
	ordType: boolean;   // true => sell, false => buy
	optId: string;
	owner: string
	amount: cBigNumber;
	refPrice: cBigNumber;
	delta: cBigNumber;
	ordPrice: cBigNumber;
	minMaxPrice: cBigNumber;

	constructor(orderResponse: iOrderResponse){
		this.ordId = orderResponse.id;
		this.ordType = orderResponse.type === 'sell';
		this.optId = orderResponse.opt_id.toString('hex');
		this.owner = orderResponse.from.toString('hex');
		this.amount = new cBigNumber(orderResponse.amount);
		this.refPrice = new cBigNumber(orderResponse.ref_price);
		this.delta = new cBigNumber(orderResponse.delta);
		this.ordPrice = new cBigNumber(orderResponse.price);
		this.minMaxPrice = new cBigNumber(orderResponse.min_max_price);
	}
}